import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const UPDATE_ACCOUNT_NOTE = gql`
  mutation UpdateAccountNote($input: UpdateAccountNoteInput!) {
    updateAccountNote(input: $input) {
      id
      title
      note
      type
      image
      image_id
      created_at
      created_by {
        id
        formatted_name
      }
    }
  }
`;

export function useUpdateAccountNote() {
  const [updateAccountNoteMutation, { loading }] =
    useMutation(UPDATE_ACCOUNT_NOTE);

  const updateAccountNote = useCallback(
    async (input) => {
      try {
        const result = await updateAccountNoteMutation({
          variables: { input },
        });
        return { success: true, data: result.data?.updateAccountNote };
      } catch (error) {
        return { success: false, error: error.message };
      }
    },
    [updateAccountNoteMutation]
  );

  return { updateAccountNote, loading };
}
